module.exports = __webpack_public_path__ + "static/media/browser.465901f8.png";